module.exports = __webpack_public_path__ + "static/mg-e2bffc9c5e6102cb1f42dd12f69b749e.png";